import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const FilterIcon = ({ fill = 'black', size = 'small' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]}>
            <path
                d="M6 12a4.002 4.002 0 0 1 3.874 3H21a1 1 0 1 1 0 2H9.874A4.002 4.002 0 0 1 2 16a4 4 0 0 1 4-4Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM18 4a4 4 0 1 1-3.874 5H3a1 1 0 0 1 0-2h11.126c.444-1.725 2.01-3 3.874-3Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
                className={fillStyles}
            />
        </svg>
    );
};
